import { useNavigate } from 'react-router-dom';
import { t } from '@app/i18n';
import { useLogout } from '@app/api/hooks/shell';
import { ROUTE_LOGIN } from '@app/navigation';
import { Card, LoadingButton } from '@zarya/ui';
import { useCurrentUser } from './useCurrentUser';
import s from './PipelineAccountScreen.module.css';

/**
 * O que vê quem entra no console com a conta da esteira de CI (aim-57a.4, protótipo
 * aprovado pelo mrolim em 04/10).
 *
 * A conta `pipeline` só anuncia releases pela API: o servidor recusa a ela toda tela
 * (403 em qualquer leitura além de `getMe`). Sem esta tela, o console abriria a moldura
 * e cada card mostraria «sem permissão» — uma recusa torta, que parece defeito. Aqui a
 * recusa é uma só e diz o que fazer: sair e entrar com uma conta de pessoa.
 */
export function PipelineAccountScreen() {
  const navigate = useNavigate();
  const { encerrar } = useCurrentUser();
  const logout = useLogout();

  return (
    <main className={s.tela}>
      <div className={s.cartao}>
        <Card title={t('login.pipelineAccount.title')}>
          <p className={s.texto}>{t('login.pipelineAccount.message')}</p>
          <div className={s.acoes}>
            <LoadingButton
              loading={logout.isPending}
              onClick={() =>
                // Igual ao «Sair» da topbar: o cookie é httpOnly e quem o expira é o
                // backend; com ou sem erro, a sessão local acaba e a pessoa vai ao login.
                logout.mutate(undefined, {
                  onSettled: () => {
                    encerrar();
                    navigate(ROUTE_LOGIN, { replace: true });
                  },
                })
              }
            >
              {t('common.ui.logout')}
            </LoadingButton>
          </div>
        </Card>
      </div>
    </main>
  );
}
